import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './services/AuthContext'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import SignupPage from './pages/SignupPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import SubscribePage from './pages/SubscribePage'
import AccountPage from './pages/AccountPage'
import AdminDashboard from './pages/AdminDashboard'
import AuthSuccessPage from './pages/AuthSuccessPage'
import ProtectedRoute from './components/ProtectedRoute'
import AuthRedirect from './components/AuthRedirect'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        
        {/* Auth redirect route - handles post-login routing */}
        <Route path="/auth-redirect" element={<AuthRedirect />} />
        <Route path="/auth-success" element={<AuthSuccessPage />} />
        
        {/* Protected routes */}
        <Route path="/subscribe" element={
          <ProtectedRoute>
            <SubscribePage />
          </ProtectedRoute>
        } />
        <Route path="/account" element={
          <ProtectedRoute>
            <AccountPage />
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute requireAdmin>
            <AdminDashboard />
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
  )
}

export default App
